import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

class ElectronService {
    constructor() {
        this._electron = window.require?.('electron');
    }
    get isElectronApp() {
        return !!this._electron;
    }
    get isMacOS() {
        return this._electron?.platform === 'darwin';
    }
    get isWindows() {
        return this._electron?.platform === 'win32';
    }
    get isLinux() {
        return this._electron?.platform === 'linux';
    }
    get isX86() {
        return this._electron?.arch === 'ia32';
    }
    get isX64() {
        return this._electron?.arch === 'x64';
    }
    get isArm() {
        return this._electron?.arch === 'arm';
    }
    get desktopCapturer() {
        return this._electron?.desktopCapturer;
    }
    get ipcRenderer() {
        return this._electron?.ipcRenderer;
    }
    get webFrame() {
        return this._electron?.webFrame;
    }
    get clipboard() {
        return this._electron?.clipboard;
    }
    get crashReporter() {
        return this._electron?.crashReporter;
    }
    get nativeImage() {
        return this._electron?.nativeImage;
    }
    get shell() {
        return this._electron?.shell;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.9", ngImport: i0, type: ElectronService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.9", ngImport: i0, type: ElectronService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.9", ngImport: i0, type: ElectronService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/*
 * Public API Surface of electron
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ElectronService };
